// extracted by mini-css-extract-plugin
export default {"wrapper":"SummaryBanner_wrapper__L9SzL","label":"SummaryBanner_label__STmba","value":"SummaryBanner_value__xHZxV"};